import { useMemo } from "react";
import { Link } from "react-router-dom";
import { CheckIcon, Pencil, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
}

const ProductPriceInCropYearPageColumn = ({ onClickDelete }: ColumnsProps) => {
  const ProductPriceInCropYearPageColumn = useMemo(
    () => [
      {
        header: "سال زارع",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: " کارخانه",
        accessorKey: "factory_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "مقدار قند (در هر تن به کیلو گرم)",
        accessorKey: "sugar_amount_per_ton_kg",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "قیمت قند (هر کیلو گرم)",
        accessorKey: "sugar_price_per_kg",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "مقدار تفاله (در هر تن به کیلوگرم)",
        accessorKey: "pulp_amount_per_ton_kg",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "قیمت تفاله (هر کیلو گرم)",
        accessorKey: "pulp_price_per_kg",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "تارخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex z-20 gap-3">
            <Link
              to="#!"
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return ProductPriceInCropYearPageColumn;
};

export default ProductPriceInCropYearPageColumn;
